import * as ActionTypes from '../ActionTypes';
const initState = {
    customerGeneralInformation: "",
    company:"",
    application:"",
    displayFiles:[],
    applicationTemplateFields:[],
  globalCounter:0
  };
  
  const CustomerReducer = (state = initState, action) => {
    switch (action.type) {
      
      case ActionTypes.LOADING:
        return {
          ...state,
          customerGeneralInformation: "loading...",
        };
      case ActionTypes.LOAD_CUSTOMER_SUCCESS:
        return {
          ...state,
          customerGeneralInformation: action.res
        };
  
      case ActionTypes.LOAD_CUSTOMER_ERROR:
        return {
          ...state,
          customerGeneralInformation: action.res,
        };
        
  
      case ActionTypes.CUSTOMER_GENERAL_INFO_STORE_SUCCESS:
        return {
          ...state,
          customerGeneralInformation: action.res,
        };
  
      case ActionTypes.CUSTOMER_GENERAL_INFO_STORE_ERROR:
        return {
          ...state,
          customerGeneralInformation: action.res,
        };
      case ActionTypes.COMPANY_STORE_SUCCESS:
        return {
          ...state,
          customerGeneralInformation: action.res,
        };

      case ActionTypes.COMPANY_STORE_ERROR:
        return {
          ...state,
          company: action.res,
        };
      case ActionTypes.CUSTOMER_VIEW_FILE_SUCCESS:
        return {
          ...state,
          displayFiles: state.displayFiles.push(action.res),
        };
      case ActionTypes.CUSTOMER_VIEW_FILE_ERROR:
        return state;
      case ActionTypes.APPLICATION_TEMPLATE_FIELDS_SUCCESS:
        return {
          ...state,
          applicationTemplateFields: action.res,
          globalStopper:true
        };
      case ActionTypes.APPLICATION_TEMPLATE_GLOBAL_COUNTER:
        return {
          ...state,
          globalCounter: state.globalCounter+1
        };

      case ActionTypes.APPLICATION_TEMPLATE_FIELDS_ERROR:
        return {
          ...state,
          applicationTemplateFields: action.res,
        };

      case ActionTypes.APPLICATION_STORE_SUCCESS:
        return {
          ...state,
          application: action.res,
        };

      case ActionTypes.APPLICATION_STORE_ERROR:
        return {
          ...state,
          application: action.res,
        };
       
      case ActionTypes.CODE_ERROR:
        return {
          ...state,
          customerGeneralInformation:
            "There seems to be a problem, please refresh your browser",
        };
  
      default:
        return state;
    }
  };
  
  export default CustomerReducer;
  